exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-env-container[data-v-2df700ea] {\n    position: absolute;\n    left: 50%;\n    width: 100%;\n    transform: translate(-50%);\n    z-index: 100;\n    cursor: pointer;\n}\n.label-env[data-v-2df700ea] {\n    z-index: 1500;\n    font-size: 12pt;\n    margin: auto;\n    display: table;\n}\n", ""]);

// exports
